export default __webpack_public_path__ + "static/media/travellogger-screenshot.78ef0740.jpg";